import { parseArrowSync } from "./parse-arrow-sync.js";
import { convertArrowToGeoJSONTable } from "../tables/convert-arrow-to-geojson-table.js";
export function parseGeoArrowSync(arrayBuffer, options) {
  const table = parseArrowSync(arrayBuffer, {
    shape: 'arrow-table'
  });
  switch (options === null || options === void 0 ? void 0 : options.shape) {
    case 'geojson-table':
      return convertArrowToGeoJSONTable(table);
    default:
      return table;
  }
}
//# sourceMappingURL=parse-geoarrow-sync.js.map